import { useEffect, useState } from "react";
import { getSliders } from "../../services/sliderService";

export default function Hero() {
 const [active, setActive] = useState(0);
 const [offers, setOffers] = useState([]);
 const offer = offers[active];

 useEffect(() => {
  getSliders().then((sliderData) => {
   setOffers(Array.isArray(sliderData) ? sliderData : []);
   setActive(0);
  });
 }, []);

 useEffect(() => {
  if (offers.length <= 1) return undefined;
  const timer = window.setInterval(() => {
   setActive((value) => (value + 1) % offers.length);
  }, 4200);

  return () => window.clearInterval(timer);
 }, [offers.length]);

 if (!offer?.image) return null;

 return (
  <section className="relative w-full overflow-hidden bg-white">
   <div className="relative h-[184px] w-full overflow-hidden bg-white sm:h-[260px] md:h-[340px] lg:aspect-[1920/650] lg:h-auto">
    <img
     className="h-full w-full object-contain"
     src={offer.image}
     alt={offer.title || "Mozo EV banner"}
    />
    {offers.length > 1 && (
     <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 gap-2 rounded-full bg-black/20 px-3 py-2 backdrop-blur" aria-label="Image slider">
      {offers.map((item, index) => (
       <button
        key={item.id || item.image}
        type="button"
        onClick={() => setActive(index)}
        className={`h-2.5 rounded-full transition ${active === index ? "w-8 bg-white" : "w-2.5 bg-white/55 hover:bg-white"}`}
        aria-label={`Show banner ${index + 1}`}
       />
      ))}
     </div>
    )}
   </div>
  </section>
 );
}
